export default __webpack_public_path__ + "CDDR-methodology.pdf";